<template>
  <div
    style="min-width: 200px;"
  >
    <label v-show="!question.is_list && fieldType.text !== null">
      <span v-html="fieldType.text"></span>
      <v-icon
        v-if="fieldType.required"
        size="10"
        color="red"
        style="vertical-align:middle;padding-left: 10px;"
      >
        mdi-asterisk
      </v-icon>
    </label>
    <div :class="'input-group'">
      <v-input
        v-model="existingFile"
        :append-icon="existingFile && !readonly ? 'close' : ''"
        prepend-icon="attachment"
        @click:append="deleteDiag = true"
        :rules="isRequired ? [v => !!v || 'Required'] : []"
        v-bind:style="(answer.status === 'follow up' || (highlightNoAnswer && !existingFile)) ? 'background:#ffffcc;' : ''"
        :messages="inputMessages"
      >
        <Preloader v-if="uploading"/>
        <v-icon
          v-if="answer.status"
          slot="prepend"
        >
          {{ statusIconClass }}
        </v-icon>
        <div v-if="existingFile && !replace">
          <v-btn
            small
            color="primary"
            :disabled="readonly"
            @click="deleteDiag = true"
          >
            Delete File
          </v-btn>
          <a
            style="font-size:18px;vertical-align:middle;text-decoration: underline;"
            @click="downloadFile()"
          >{{existingFile}}
          </a>
        </div>
        <div v-else>
          <form
            v-if="!readonly"
            method="post"
            style="display:inline;"
          >
            <div style="display:inline;height:32px;color:lightgrey;font-size:18px;">
              <input
                type="file"
                ref="files"
                :required="fieldType.required"
                :disabled="readonly"
                v-on:change="handleFileUploads()"
              />
            </div>
          </form>
          <span v-else>
            <span
              style="font-size:18px;vertical-align:middle;color:lightgrey;"
            >
              No file uploaded
            </span>
          </span>
        </div>
      </v-input>
      <slot></slot>
    </div>
    <TryAgain
      v-if="failed"
      :message="'Save'"
      @try="save"
    />
    <v-dialog
      v-model="deleteDiag"
      width="350"
    >
      <v-card>
        <v-toolbar
          dense
          color="red"
          dark
        >
          Are you sure?
        </v-toolbar>
        <v-card-text>
          You are deleting {{existingFile}} from your form. This action cannot be undone.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="deleteDiag = false"
          >
            No
          </v-btn>
          <v-btn
            @click="deleteFile()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import answerMixin from './answermixin'
import TryAgain from './TryAgain'
import Preloader from '@/components/global/Preloader'
import api from '@/api'

export default {
  name: 'FileAnswer',
  mixins: [answerMixin],
  props: [ 'readonly', 'showLastUpdated' ],
  components: {
    TryAgain,
    Preloader
  },
  data () {
    return {
      existingFile: '',
      replace: false,
      value: '',
      savedValue: '',
      uploading: false,
      failed: false,
      deleteDiag: false
    }
  },
  beforeMount () {
    this.existingFile = this.answer.file || ''
    this.savedValue = this.existingFile
  },
  computed: {
    inputMessages () {
      var messages = []
      if (this.showLastUpdated && this.answer.updated_at)
        messages.push([`${this.convertToLocal(this.answer.updated_at)} by ${this.answer.updated_by_name}`])
      return messages
    }
  },
  methods: {
    handleFileUploads () {
      this.uploading = true
      this.value = this.$refs.files.files
      this.save()
        .then(() => {
          this.existingFile = this.answer.file || ''
        })
    },
    downloadFile () {
      this.uploading = true
      var answerObject = {
        client_id: this.listId ? (this.listId.uuid || null) : null,
        fieldtype_id: this.fieldType.id,
        list_id: this.listId ? (this.listId.id || null) : null,
        question_id: this.question.id
      }
      if (this.isClient) {
        var downloadFileAction = api.userform.contactUserForm.downloadFileAnswer(this.userFormId, answerObject)
      } else {
        var downloadFileAction = api.userform.userForm.downloadFileAnswer(this.userFormId, answerObject)
      }
      downloadFileAction
        .then(response => {
          this.uploading = false
          let blob = new Blob([response.data])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.existingFile
          link.click()
        })
    }, 
    deleteFile () {
      this.value = ''
      this.save()
      .then(() => {
        this.replace = true
        this.deleteDiag = false
        this.existingFile = null
      })
    }
  },
  watch: {
    savedValue () {
      for( var i = 0; i < this.savedValue.length; i++ ){
        let file = this.savedValue[i]
        this.existingFile = this.answer.file || ''
      }
      this.replace = false
      this.uploading = false
    }
  }
}
</script>
